module.exports = __webpack_public_path__ + "static/fate-is-the-hunter-b4c9dd64cef4cf4dcba87e0b236fd0cb.jpg";